var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "60px",
    viewBox: "0 0 17.00 17.00",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-finger-up",
    fill: "#000000",
    transform: "rotate(90)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "703"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.00017,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 0.000000)",
    fill: "#191847"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.048,13.172 L5.048,14.798 C5.048,15.427 5.526,15.939 6.114,15.939 L10.902,15.939 C11.492,15.939 11.968,15.427 11.968,14.798 L11.968,13.172 C11.968,12.541 11.491,12.03 10.902,12.03 L6.114,12.03 C5.525,12.03 5.048,12.541 5.048,13.172 L5.048,13.172 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.988,4.074 L5.999,0.941 C5.999,0.941 5.797,0.02 5.125,0.02 C4.378,0.02 4.018,0.378 4.018,1.022 L4.018,4.892 C4.018,7.221 3.263,6.847 3.263,6.847 L1.355,6.062 C0.173,6.062 0.017,6.332 0.017,6.947 C0.416,7.992 4.02,9.804 4.02,9.804 C5.153,10.138 5.7,10.937 5.7,10.937 L10.974,10.999 L10.955,10.477 C10.955,8.917 11.963,8.732 11.963,8.088 L11.963,4.315 C11.963,3.672 11.451,3.021 10.818,3.021 L10.02,3.021 L10.02,4.021 L8.959,4.021 L8.959,2.625 C8.959,2.539 8.937,2.459 8.901,2.385 C8.803,2.176 8.276,2.018 8.019,2.018 C7.688,2.018 7.034,2.272 7.008,2.58 C7.007,2.597 6.998,4.021 6.998,4.021 L5.988,4.074 L5.988,4.074 Z",
    className: "si-glyph-fill"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.caf9b615fe4017f33d1032da0e1b0e79.svg";
export { ForwardRef as ReactComponent };